import { eventsSearchThunks } from '@ucheba/store/events/search'
import { eventsMyThunks } from '@ucheba/store/events/my'
import { locationThunks } from '@ucheba/store/location'
import { authSelectors } from '@ucheba/store/auth'
import { NextPageContext } from 'next/dist/shared/lib/utils'
import { parseUrl } from '@ucheba/utils/helpers/router'
import { NextRouter } from 'next/router'
import { Store } from 'redux'
import { profileSelectors, profileThunks } from '@ucheba/store/profile'
import EventsPage from './index'
import { slugs } from './index/constants'

EventsPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store } = ctx
  const { dispatch, getState } = store
  const query = parseUrl(ctx.asPath || '').query as NextRouter['query']
  const isAuth = authSelectors.isAuth(store.getState())

  // если в квери параметрах нет programTypes, то добавляем все programTypes, за исключением типа 'все'
  if (!query.programTypes) {
    query.programTypes = slugs
  }

  await Promise.all([
    dispatch<any>(
      eventsSearchThunks.fetch({
        ctx,
        data: {
          ...query,
          rubricId: 2,
          isFinished: 0,
        },
      })
    ),
    isAuth && dispatch<any>(eventsMyThunks.fetch({ ctx })),
  ])

  if (query.locationIds && query.locationIds.length === 1) {
    await dispatch<any>(
      locationThunks.getByLocationIds({
        ctx,
        data: { id: query.locationIds[0] },
      })
    )
  }

  const profile = profileSelectors.entity(getState())

  if (!profile) {
    await dispatch(profileThunks.get({ ctx }))
  }

  return {
    query,
    content: {
      seo: {
        meta: {
          title: 'Дни открытых дверей',
          description: 'Дни открытых дверей',
        },
      },
    },
  }
}

export default EventsPage
